import { RootState } from "../../redux/rootReducers";
import { useSelector } from "react-redux";

export const usePerfil = (perfil: string) => {
  const { IdPerfil } = useSelector((store: RootState) => store.login);

  const isPerfil = false;

  try {
    if (IdPerfil === String(perfil)) {
      return { isPerfil: true };
    } else {
      return { isPerfil: false };
    }
  } catch (error) {
    console.error("Error al verificar el perfil:", error);
    return { isPerfil: false };
  }
};

export const usePerfilUser = () => {
  const { IdPerfil } = useSelector((store: RootState) => store.login);

  const stroreStoragePerfils = IdPerfil ? IdPerfil : "0";

  return stroreStoragePerfils;
};

export const useIdCliente = () => {
  const { IdCliente } = useSelector((store: RootState) => store.login);
  const storeIdCliente = IdCliente ? IdCliente : "0";

  return storeIdCliente;
};
